import React from "react";
import "./styles.less";
import { useTranslation } from "react-i18next";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { tryNow } from "../../utils";
import { CommonConsult } from "../common-consult";
import Tooltip from "rc-tooltip";

export const PricePageBanner = () => {
  const { t } = useTranslation();

  return (
    <>
      <div className="price-banner">
        <div className="inner">
          <h1 className="title">
            {t("price.banner.title")}
            <Tooltip
              placement="bottom"
              mouseLeaveDelay={0.001}
              trigger={["hover"]}
              overlay={<div>{t("price.banner.common-tip")}</div>}
            >
              <span className="mauStyle">{t("price.banner.MAU")}</span>
            </Tooltip>
            {t("price.banner.title-other")}
          </h1>
          <div className="subtitle">{t("price.banner.subtitle")}</div>
          <div className="content-warp">
            <div className="item dark" onClick={tryNow}>
              <div className="item-title">
                {t("price.banner.section-one.title")}
              </div>
              <div className="item-text ">
                {t("price.banner.section-one.descript")}
              </div>
              <div className="item-button light" onClick={tryNow}>
                {t("price.banner.section-one.button")}
              </div>
            </div>

            <a className="item light" href="/solutions/private-cloud">
              <div className="item-title">
                {t("price.banner.section-two.title")}
              </div>
              <div className="item-text">
                {t("price.banner.section-two.descript")}
              </div>
              <div className="item-button dark">
                {t("price.banner.section-two.button")}
              </div>
            </a>
          </div>
        </div>
      </div>
    </>
  );
};
